import { produce } from "immer";

import { tConfigsAction, tConfigsState } from "./types";

const defaultState = {
  isLoading: true,
  isError: false,
  data: {},
  error: null,
};

export const ConfigsReducer = produce((state: tConfigsState = defaultState, action: tConfigsAction): tConfigsState => {
  switch (action.type) {
    case "SET_CONFIGS":
      state.isLoading = false;
      state.data = action.payload;
      return state;
    case "SET_CONFIGS_ERROR":
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
      return state;
    default:
      return state;
  }
});
